export default __webpack_public_path__ + "static/media/Talent_PetPal.b4636ccd.png";